import { FormattedMessage } from 'react-intl'
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Typography
} from '@carto/meridian-ds/components'
import { ProcessingJob } from 'features/jobs/types'

function JobItemProcessSQLQueryDialog({
  job,
  open,
  onClose
}: {
  job: ProcessingJob
  open: boolean
  onClose: () => void
}) {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="job-sql-dialog-title" size="medium">
      <DialogHeader id="job-sql-dialog-title" title={<FormattedMessage id="jobs.customQuery" />} />

      <DialogContent>
        <Typography variant="caption" color="textSecondary">
          <FormattedMessage id="jobs.tilesets.query" />
        </Typography>

        <Alert severity="success">{job.status?.query}</Alert>
      </DialogContent>

      <DialogFooter>
        <Button onClick={onClose} color="primary">
          <FormattedMessage id="common.button.done" />
        </Button>
      </DialogFooter>
    </Dialog>
  )
}

export default JobItemProcessSQLQueryDialog
